import React, { useEffect, useState } from 'react'
import Select from 'react-select'

import { Search, Tune } from '@mui/icons-material'
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import userPoint from "../../assets/svg/point-user.svg"
import Expand from "../../assets/svg/Expand icon.svg"
import Edit from "../../assets/svg/Vector.svg"
import Trash from "../../assets/svg/trash-bin-trash-svgrepo-com 1.svg"
import {
  Button,
  Popper,
  Paper,
  Checkbox,
  FormGroup,
  FormControlLabel,
  ClickAwayListener,
  Box,
  Pagination,
} from '@mui/material';
import "./PointsTransaction.css";
const PointsTransaction = () => {
  // const [open, setOpen] = useState(false);
  // const [checkedItems, setCheckedItems] = useState([]);

  // const toggleDrawer = (state) => () => {
  //   setOpen(state);
  // };

  // const handleToggle = (item) => () => {
  //   setCheckedItems((prev) =>
  //     prev.includes(item)
  //       ? prev.filter((i) => i !== item)
  //       : [...prev, item]
  //   );
  // };
  const filterItems = [
    'Register',
    'First Order',
    'Third Order',
    'Fifth Order',
    'Rating',
    'Birthdate',
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const [checkedItems, setCheckedItems] = useState([]);

  const handleToggle = (item) => {
    setCheckedItems((prev) =>
      prev.includes(item)
        ? prev.filter((i) => i !== item)
        : [...prev, item]
    );
  };

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const [sortBy, setSortBy] = useState(null);
  const [sortPoint, setSortPoint] = useState("asc");
  const [sortedPoints, setSortedPoints] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [totalPoints, setTotalPoints] = useState(0);



 const totalPages = Math.ceil(totalPoints / itemsPerPage); 


  const options = [
    { value: '10', label: '10' },
    { value: '50', label: '50' },
    { value: '100', label: '100' }
  ]
  const points = [{
    id: "1",
    userProfile: "Ahmed Ali Abdallah",
    phoneNumber: "01003247882",
    transactionsType: "discount",
    points: "100",
    actionType: "First Order",
    createdAt: "July 20 . 2025 03:00 pm ",
    description: "Completed maintenance service"


  }, {
    id: "2",
    userProfile: "Ahmed Ali Abdallah",
    phoneNumber: "01003247882",
    transactionsType: "discount",
    points: "90",
    actionType: "First Order",
    createdAt: "July 20 . 2025 03:00 pm "

  }, {
    id: "3",
    userProfile: "Ahmed Ali Abdallah",
    phoneNumber: "01003247882",
    transactionsType: "discount",
    points: "80",
    actionType: "First Order",
    createdAt: "July 20 . 2025 03:00 pm "

  }, {
    id: "1",
    userProfile: "Ahmed Ali Abdallah",
    phoneNumber: "01003247882",
    transactionsType: "discount",
    points: "100",
    actionType: "First Order",
    createdAt: "July 20 . 2025 03:00 pm "

  }, {
    id: "1",
    userProfile: "Ahmed Ali Abdallah",
    phoneNumber: "01003247882",
    transactionsType: "discount",
    points: "100",
    actionType: "First Order",
    createdAt: "July 20 . 2025 03:00 pm "

  }, {
    id: "1",
    userProfile: "Ahmed Ali Abdallah",
    phoneNumber: "01003247882",
    transactionsType: "discount",
    points: "100",
    actionType: "First Order",
    createdAt: "July 20 . 2025 03:00 pm "

  },]

  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: "110px",
      minWidth: "unset"

    }),
  };
  const sortPoints = (pointsToSort, currentSortBy, currentSortPoint) => {
    if (!currentSortBy) {
      return [...pointsToSort];
    }

    return [...pointsToSort].sort((a, b) => {
      let comparison = 0;

      if (currentSortBy === "id") {
        comparison = a.id - b.id;
      } else if (currentSortBy === "userProfile") {
        const userA = a.userProfile || "";
        const userB = b.userProfile || "";
        comparison = userA.localeCompare(userB);
      } else if (currentSortBy === "phoneNumber") {
        const phoneA = a.phoneNumber || "";
        const phoneB = b.phoneNumber || "";
        comparison = phoneA.localeCompare(phoneB);
      } else if (currentSortBy === "transactionsType") {
        const typeA = a.transactionsType || "";
        const typeB = b.transactionsType || "";
        comparison = typeA.localeCompare(typeB);
      } else if (currentSortBy === "points") {
        const pointA = a.points || "";
        const pointB = b.points || "";
        comparison = pointA.localeCompare(pointB);
      }
      else if (currentSortBy === "actionType"){
        const actionA = a.points || "";
        const actionB = b.points || ""; 
        comparison = actionA.localeCompare(actionB);
      }
      else if (currentSortBy === "createdAt") {
        const createdA = a.createdAt || "";
        const createdB = b.createdAt || "";
        comparison = createdA.localeCompare(createdB);
      }

      return currentSortPoint === "asc" ? comparison : comparison * -1;
    });
  };
  const handleSort = (columnName) => {
    const newSortPoint =
      sortBy === columnName && sortPoint === "asc" ? "desc" : "asc";
    setSortBy(columnName);
    setSortPoint(newSortPoint);
  };

  const getSortIcon = (columnName) => {
    if (sortBy === columnName) {
      return sortPoint === "asc" ? (
        <ArrowUpwardIcon fontSize="small" />
      ) : (
        <ArrowDownwardIcon fontSize="small" />
      );
    }
    return null;
  };
  const [expandedPointId, setExpandedPointId] = useState(null);
  const toggleDrawer = (pointId) => {
    setExpandedPointId((prevId) => {
      return prevId === pointId ? null : pointId;
    });
  };

  useEffect(() => {
    if (points.length > 0) {
      const initialSortBy = sortBy || "id";
      const sorted = sortPoints(points, initialSortBy, sortPoint);
      setSortedPoints(sorted);
      setSortBy(initialSortBy);
    } else {
      setSortedPoints([]);
    }

  }, []);

  return (
    <>
      <div className="m-4 min-vh-100">
        <h5 className="fw-bold">Points Transaction</h5>
        <div className="row  align-items-center ">
          <div className="col-md-6 col-sm-12 d-flex align-items-center  gap-3 py-2">
            {" "}
            <Select styles={customStyles} options={options} />
            <p className="selection-page mb-0">entries per page</p>
          </div>
          <div className="col-md-6 col-sm-12 justify-content-end d-flex gap-2">
            <div className="w-100 d-flex align-items-center justify-content-end position-relative ">
              <input
                className="w-100 py-2 ps-3 pe-5  rounded-2 search-point"
                type="text"
                placeholder="Search by ID, name, category... "
              />
              <Search sx={{ color: " #535353", position: "absolute" }} />
            </div>
            <button onClick={handleClick} className="btn btn-light">
              <Tune />
            </button>
            <Popper open={open} anchorEl={anchorEl} placement="bottom-end">
              <ClickAwayListener onClickAway={handleClose}>
                <Paper
                  sx={{
                    mt: 1,
                    p: 2,
                    boxShadow: 3,
                    borderRadius: 2,
                    minWidth: 200,
                  }}
                >
                  <FormGroup>
                    {filterItems.map((item) => (
                      <FormControlLabel
                        key={item}
                        control={
                          <Checkbox
                            checked={checkedItems.includes(item)}
                            onChange={() => handleToggle(item)}
                          />
                        }
                        label={item}
                      />
                    ))}
                  </FormGroup>
                </Paper>
              </ClickAwayListener>
            </Popper>
          </div>
        </div>
        <div className="table-responsive ">
          <table className="table table-hover border custom-table">
            <thead className="table-light">
              <tr className="table-header">
                <th
                  onClick={() => handleSort("id")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center">
                    <input
                      className="mx-1"
                      type="checkbox"
                      aria-label="Select All Orders"
                      // onChange={(e) => {
                      //     if (e.target.checked) {
                      //         setSelectedOrders(getPaginatedOrders());
                      //     } else {
                      //         setSelectedOrders([]);
                      //     }
                      // }}
                      // checked={
                      //     selectedOrders.length ===
                      //     getPaginatedOrders().length &&
                      //     getPaginatedOrders().length > 0
                      // }
                    />
                    <p className='my-0'> ID {getSortIcon("id")}</p>
                  </div>
                </th>
                {/* <th
                                                onClick={() => handleSort("id")}
                                                style={{ cursor: "pointer" }}
                                            >
                                                ID {getSortIcon("id")}
                                            </th> */}
                <th
                  onClick={() => handleSort("userProfile")}
                  style={{ cursor: "pointer" }}
                >
                  User Profile {getSortIcon("userProfile")}
                </th>
                <th
                  onClick={() => handleSort("transactionType")}
                  style={{ cursor: "pointer" }}
                >
                  Transactions Type{getSortIcon("transactionType")}
                </th>
                <th
                  onClick={() => handleSort("points")}
                  style={{ cursor: "pointer" }}
                >
                  Points {getSortIcon("points")}
                </th>
                <th
                  onClick={() => handleSort("actionType")}
                  style={{ cursor: "pointer" }}
                >
                  Action Type {getSortIcon("actionType")}
                </th>
                <th
                  onClick={() => handleSort("createdAt")}
                  style={{ cursor: "pointer" }}
                >
                  Created At {getSortIcon("createdAt")}
                </th>

                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {points.map((point, index) => (
                <React.Fragment key={point.id}>
                  <tr className={index % 2 === 0 ? "row-light" : "row-dark"}>
                    <td className="py-0">
                      <div className="d-flex mx-2 ">
                        {" "}
                        <input
                          type="checkbox"
                          // aria-label={`Select Order ${order.id}`}
                          // checked={selectedOrders.some(
                          //     (selectedOrder) => selectedOrder.id === order.id
                          // )}
                          // onChange={(e) =>
                          //     handleSelectOrderChange(order, e.target.checked)
                          // }
                        />
                        <p className="mt-3 mx-1">{point.id}</p>{" "}
                      </div>
                    </td>
                    <td
                      // onClick={() => navigateToOrderdetails(order.id)}
                      className=" "
                    >
                      <div className="d-flex align-items-center justify-content-center  ">
                        <img src={userPoint} alt="" />
                        <div className=" mx-2">
                          {" "}
                          <p className="m-0">{point.userProfile}</p>{" "}
                          <p className="m-0">{point.phoneNumber}</p>
                        </div>
                      </div>
                    </td>
                    <td className="">{point.transactionsType}</td>
                    {/* <td>
                                                        <div className="d-flex align-items-center justify-content-start">
                                                            <span>{order.service}</span>
                                                            {order.service_categories?.map((cat) => (
                                                                <img
                                                                    key={cat?.icon_url}
                                                                    src={
                                                                        "https://estbn.com/MobileAppBackend/public/" +
                                                                        cat?.icon_url || Estbn
                                                                    }
                                                                    alt={cat?.name || "Service Icon"}
                                                                    style={{
                                                                        width: "30px",
                                                                        height: "30px",
                                                                        marginLeft: "5px",
                                                                    }}
                                                                />
                                                            ))}
                                                        </div>
                                                    </td> */}
                    <td>{point.points}</td>
                    <td>{point.actionType}</td>
                    <td>{point.createdAt}</td>
                    {/* <td>
                                                        <img
                                                            src={
                                                                "https://estbn.com/MobileAppBackend/public/" +
                                                                order.request_status.icon_url
                                                            }
                                                            alt={order.request_status.name}
                                                            style={{ width: "30px", height: "30px" }}
                                                        />
                                                    </td> */}
                    <td>
                      <div className="action-container-points">
                        <img
                          src={Edit}
                          alt="Edit Icon"
                          // onClick={() => toggleDrawer(order.id)}
                          className="action-icon clickable"
                          style={{ cursor: "pointer" }}
                        />
                        <img
                          src={Trash}
                          alt="Trash Icon"
                          // onClick={() => navigateToOrderdetails(order.id)}
                          className="action-icon clickable"
                        />
                        <img
                          src={Expand}
                          alt="Expand Icon"
                          // onClick={() => navigateToActivity(order.id)}
                          onClick={() => toggleDrawer(point.id)}
                          className="action-icon clickable"
                        />
                      </div>
                    </td>
                  </tr>
                  {expandedPointId === point.id && (
                    <tr className="expanded-row">
                      <td className="p-0" colSpan="12">
                        <div
                          className="row"
                          style={{ padding: "10px", background: "#f9f9f9" }}
                        >
                          <div className="text-center col-md-2">
                            <p className=" black-text">
                              Transaction Description
                            </p>
                            <p className="gray-text">{point.description}</p>
                          </div>
                          {/* <div className="detail-row">
                                                                    <p className="gray-text">Email:</p>
                                                                    <p className="black-text">
                                                                        {point}
                                                                    </p>
                                                                </div>
                                                                <div className="detail-row">
                                                                    <p className="gray-text">Order Date:</p>
                                                                    <p className="black-text">
                                                                        {dayjs(order.created_at).format(
                                                                            "YYYY-MM-DD"
                                                                        )}
                                                                    </p>
                                                                </div>
                                                                <div className="detail-row">
                                                                    <p className="gray-text">Price:</p>
                                                                    <p className="black-text">
                                                                        {order.total_price}
                                                                    </p>
                                                                </div>

                                                                <div className="detail-row">
                                                                    <p className="gray-text">Agent Name:</p>
                                                                    <p className="black-text">
                                                                        {order.agent
                                                                            ?.map((cat) => cat.name)
                                                                            .join(", ") || " "}
                                                                    </p>
                                                                </div>
                                                                <div className="detail-row">
                                                                    <p className="gray-text">Stock:</p>
                                                                    <p className="black-text">Available</p>
                                                                </div>
                                                                <div className="detail-row">
                                                                    <p className="gray-text">Car Model:</p>
                                                                    <p className="black-text">
                                                                        {order.car?.name || " "}
                                                                    </p>
                                                                </div> */}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box sx={{ width: 300, p: 2 }}>
          <Typography sx={{ color: "#535353" }} variant="h6" gutterBottom>
            Choose Category          </Typography>
          <List>
            {filterItems.map((item) => (
              <ListItem
                key={item}
                button
                onClick={handleToggle(item)}
                disablePadding
              >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={checkedItems.includes(item)}
                    tabIndex={-1}
                    disableRipple
                  />
                </ListItemIcon>
                <ListItemText primary={item} />
              </ListItem>
            ))}
          </List>

        </Box>
      </Drawer> */}
      <Pagination className=" d-flex justify-content-end">
        <Pagination.First
          onClick={() => setCurrentPage(1)}
          disabled={currentPage === 1}
        />
        <Pagination.Prev
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        />

        {[...Array(totalPages)].map((_, idx) => (
          <Pagination.Item
            className="pagination-btn"
            key={idx + 1}
            active={idx + 1 === currentPage}
            onClick={() => setCurrentPage(idx + 1)}
          >
            {idx + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
        />
        <Pagination.Last
          onClick={() => setCurrentPage(totalPages)}
          disabled={currentPage === totalPages}
        />
      </Pagination>
    </>
  );
}

export default PointsTransaction